import React from "react";
import "./SideProgressBar1.scss";

interface FlowItem {
  id: number | string;
  name: string;
  childs?: FlowItem[];
}

interface Props {
  tree: FlowItem[];
  currentIndex: number;
  currentChildIndex: number;
  currentGrandChildIndex: number;
  completed: (number | string)[];
}

const SideProgressBar1: React.FC<Props> = ({
  tree,
  currentIndex,
  currentChildIndex,
  currentGrandChildIndex,
  completed,
}) => {
  const visibleSteps: {
    id: number | string;
    name: string;
    level: number;
  }[] = [];

  tree.forEach((main, mainIndex) => {
    const isMainCurrent = mainIndex === currentIndex;

    // MAIN
    visibleSteps.push({
      id: main.id,
      name: main.name,
      level: 0,
    });

    if (isMainCurrent && main.childs?.length) {
      main.childs.forEach((child, childIndex) => {
        visibleSteps.push({
          id: child.id,
          name: child.name,
          level: 1,
        });

        if (
          childIndex === currentChildIndex &&
          currentGrandChildIndex >= 0 &&
          child.childs?.length
        ) {
          child.childs.forEach((grand) => {
            visibleSteps.push({
              id: grand.id,
              name: grand.name,
              level: 2,
            });
          });
        }
      });
    }
  });
  const allSteps: (number | string)[] = [];
  
  const flatten = (items: FlowItem[]) => {
    items.forEach((item) => {
      allSteps.push(item.id);
      if (item.childs?.length) flatten(item.childs);
    });
  };

  flatten(tree);

  const total = allSteps.length;

  const uniqueCompleted = Array.from(new Set(completed));
  const done = uniqueCompleted.length;

  const progressPercent =
    total === 0 ? 0 : done >= total ? 100 : (done / total) * 100;
  const currentMainId = tree[currentIndex]?.id;
  const currentChildId =
    tree[currentIndex]?.childs?.[currentChildIndex]?.id;
  const currentGrandId =
    tree[currentIndex]?.childs?.[currentChildIndex]?.childs?.[
      currentGrandChildIndex
    ]?.id;

  return (
    <div className="side-progress-bar">
      <div className="progress-line-bg">
      <div
        className="progress-line-fill"
        style={{ height: `${progressPercent}%` }}
      />
      </div>

      {visibleSteps.map((step, index) => {
        const isCompleted = uniqueCompleted.includes(step.id);
        const isCurrent =
          step.id === currentMainId ||
          step.id === currentChildId ||
          step.id === currentGrandId;

        return (
          <div
            key={index}
            className={`progress-item level-${step.level}
              ${isCompleted ? "completed" : ""}
              ${isCurrent ? "current" : ""}
            `}
          >
            {step.name}
          </div>
        );
      })}
    </div>
  );
};

export default SideProgressBar1;